import gql from 'fake-tag'
import { cache } from 'services'

import DefaultClient from './DefaultClient'

class RemoteWorkGuidesClient extends DefaultClient {
    constructor() {
        super(cache.keys.REMOTE_WORK_GUIDES)
    }

    async getBlogIndex(lang = 'en') {
        const locale = this.getLocale(lang)
        const cacheKey = 'BlogIndex'
        const cache = this.cache.get(cacheKey)
        if (cache) return cache

        const data = await this.queryGraphQL(gql`
            {
                blogIndex(id: "SjIiUEVKz73G67cWZPVO6", locale: "${locale}") {
                    title
                    description
                    postsCollection {
                        items {
                            ... on BlogPost {
                                slug
                                title
                                thumbnailImage {
                                    alt: title
                                    url
                                }
                            }
                        }
                    }
                }
            }
        `)

        if (!data) {
            throw new Error('Remote Work Guides: blog index not found on Contentful.')
        }

        this.cache.set(cacheKey, data.blogIndex)

        return data.blogIndex
    }

    async getBlogPost(slug: string, lang = 'en') {
        const locale = this.getLocale(lang)
        const cacheKey = `bp-${lang}-${slug}`
        const cache = this.cache.get(cacheKey)
        if (cache) return cache

        const data = await this.queryGraphQL(gql`
            {
                blogPostCollection(where: { slug: "${slug}" }, limit: 1) {
                    items {
                        title: title(locale: "${locale}")
                        description: description(locale: "${locale}")
                        backgroundColor
                        seo: seo(locale: "${locale}") {
                            title
                            description
                            image: ogimage {
                                alt: title
                                url
                            }
                        }
                        coverImage: coverImage(locale: "${locale}") {
                            alt: title
                            url
                        }
                        content: content(locale: "${locale}") {
                            links {
                                assets {
                                    block {
                                        sys {
                                            id
                                        }
                                        title
                                        description
                                        url
                                    }
                                }
                                entries {
                                    block {
                                        __typename
                                        sys {
                                            id
                                        }
                                        ... on BlogImageHeading {
                                            title
                                            level
                                            image {
                                                alt: title
                                                url
                                            }
                                        }
                                        ... on BlogExpertBox {
                                            expert {
                                                name
                                                description
                                                avatar {
                                                    alt: title
                                                    url
                                                }
                                            }
                                            content
                                        }
                                        ... on ArticleTable {
                                            columnsCollection {
                                                items {
                                                    title
                                                    row1
                                                    row2
                                                    row3
                                                    row4
                                                    row5
                                                    row6
                                                    row7
                                                    row8
                                                }
                                            }
                                        }
                                        ... on BlogTip {
                                            title
                                            content
                                        }
                                    }
                                }
                            }
                            json
                        }
                    }
                }
            }
        `)

        const [blogPost] = data?.blogPostCollection.items ?? []

        this.cache.set(cacheKey, blogPost)

        return blogPost
    }
}

export default new RemoteWorkGuidesClient()
